module.exports = __webpack_public_path__ + "img/loading-quote-img-5.3d945349.png";